import { CampaignMessage } from '../models/CampaignMessage';
import { Conversation } from '../models/Conversation';

export function isConversation(item: Conversation | CampaignMessage): item is Conversation {
  return (item as Conversation).messages !== undefined;
}
